import { render, staticRenderFns } from "./TeaorSelector.vue?vue&type=template&id=121a3445"
import script from "./TeaorSelector.vue?vue&type=script&lang=js"
export * from "./TeaorSelector.vue?vue&type=script&lang=js"
import style0 from "./TeaorSelector.vue?vue&type=style&index=0&id=121a3445&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports